.toolbar {
  position: relative;
  height: calc(5 * var(--spacer));
  padding: 0 var(--spacer);
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: var(--chart-101-pressed-dividers);
  }
}

.toolbar-button {
  border: none;
  background-color: transparent;
  width: calc(4 * var(--spacer));
  height: calc(4 * var(--spacer));
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease 0s, color 0.3s ease 0s;

  &:hover {
    background-color: var(--chart-050-hover);
  }

  &:active {
    color: var(--main-titles-inputs-600);
  }

  &:focus-visible {
    border: 1px solid var(--blue-layout-500-focus);
    outline: none;
  }
}

.format-controls {
  display: flex;
  justify-content: center;
  justify-content: center;
  align-items: center;

  > * {
    margin-right: calc(2 * var(--spacer));
  }

  .divider {
    display: block;
    width: 1px;
    height: calc(2 * var(--spacer));
    background-color: var(--chart-101-pressed-dividers);
  }
}

.actions {
  display: flex;
  justify-content: center;
  align-items: center;

  > * {
    margin-left: calc(2 * var(--spacer));
  }
}

.text-size-select {
  display: flex;
  justify-content: center;
  height: calc(4 * var(--spacer));
  cursor: pointer;
  margin-left: 4px;
}

.selected-text-size {
  font-size: var(--body-size);
  font-family: var(--font-family-secondary);
  display: inline-block;
  transform: translateY(-12px);
  min-width: 112px;
  margin-right: 4px;
  color: var(--body-text-arrows-400);
}

gz-icon-button {
  height: calc(4 * var(--spacer));
}
